import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

export default function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    const page = loc.pathname || "/";
    api.post("/track/page", { page, referrer: document.referrer || "" }).catch(() => {});
  }, [loc.pathname]);
  return null;
}
